import { Modal } from "antd"
import { useRevokeGroupRoleAssignment } from "@mimber/client/mimber-organization"
import { message } from "@mimber/ui-web"
import type { GroupRoleAssignmentWithRelationsDto } from "@mimber/schema"

export interface ShowRevokeGroupRoleAssignmentModalOptions {
  assignment: GroupRoleAssignmentWithRelationsDto
}

export const useRevokeGroupRoleAssignmentModal = (roleUuid: string) => {
  const [modal, contextHolder] = Modal.useModal()
  const revokeMutation = useRevokeGroupRoleAssignment(roleUuid, {
    onSuccess: () => {
      message.success("Group assignment revoked successfully")
    },
    onError: (err) => {
      message.error(`Failed to revoke group assignment: ${err.message}`)
    },
  })

  const showRevokeGroupRoleAssignmentModal = ({
    assignment,
  }: ShowRevokeGroupRoleAssignmentModalOptions): void => {
    modal.confirm({
      title: "Revoke Group Assignment",
      content: `Are you sure you want to revoke the role assignment for "${assignment.group.name}"? All members of this group will lose the permissions from this role.`,
      okText: "Revoke",
      okType: "primary",
      okButtonProps: { danger: true },
      cancelText: "Cancel",
      onOk: () =>
        new Promise<void>((resolve, reject) => {
          revokeMutation.mutate(
            { assignmentUuid: assignment.uuid },
            {
              onSuccess: () => resolve(),
              onError: () => reject(),
            }
          )
        }),
    })
  }

  return {
    contextHolder,
    showRevokeGroupRoleAssignmentModal,
  }
}
